export default __webpack_public_path__ + "static/national-metric-mobile-0d11effd43b2edd222bfb82211852d7a.svg";